import { Component, inject, OnInit } from '@angular/core';
import { GlobalPageHeaderComponent } from '../../../../../../../../components/global-page-header/global-page-header.component';
import {
  IonButton,
  IonContent,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-p0003600-en-savoir-plus',
  templateUrl: './p0003600-en-savoir-plus.component.html',
  styleUrls: ['./p0003600-en-savoir-plus.component.scss'],
  imports: [GlobalPageHeaderComponent, IonButton, IonContent, TranslatePipe],
})
export class P0003600EnSavoirPlusComponent {
  private modalController: ModalController = inject(ModalController);

  constructor() {}

  async dismissModal() {
    await this.modalController.dismiss();
  }
}
